import { render, staticRenderFns } from "./LoginForce2FA.vue?vue&type=template&id=4b0b8101&"
import script from "./LoginForce2FA.vue?vue&type=script&lang=js&"
export * from "./LoginForce2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b0b8101')) {
      api.createRecord('4b0b8101', component.options)
    } else {
      api.reload('4b0b8101', component.options)
    }
    module.hot.accept("./LoginForce2FA.vue?vue&type=template&id=4b0b8101&", function () {
      api.rerender('4b0b8101', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user_login/LoginForce2FA.vue"
export default component.exports